import styled from 'styled-components'
import {colorWine} from '../../cssConstants/colors'
import {spacingMedium} from '../../cssConstants/spacing'

export const Title = styled.h1`
  font-family: 'Museo 300';
  font-style: normal;
  font-weight: normal;
  letter-spacing: 2px;
  color: ${colorWine};
  font-size: 50px;
  ${'' /* font-weight: 300; */}
  line-height: 1.1;
  margin-bottom: ${spacingMedium}rem;
  text-align: center;
`
